import React from 'react';
import IWaveStat from '@/constants/integrations/IWaveStat';
import translate from '@/lib/intl/translate';
import IWaveSearchFilter from './IWaveSearchFilter';

export default function IWaveSearchFilters() {
  return (
    <>
      <h3 className="type-body2">{translate('IWAVE_FILTER_SUBHEADER')}</h3>

      <IWaveSearchFilter
        label={translate('IWAVE_FILTER_IWAVE_LABEL')}
        name={IWaveStat.SCORE}
      />

      <IWaveSearchFilter
        label={translate('IWAVE_FILTER_CAPACITY_LABEL')}
        name={IWaveStat.CAPACITY}
      />

      <IWaveSearchFilter
        label={translate('IWAVE_FILTER_PROPENSITY_LABEL')}
        name={IWaveStat.PROPENSITY}
      />

      <IWaveSearchFilter
        label={translate('IWAVE_FILTER_AFFINITY_LABEL')}
        name={IWaveStat.AFFINITY}
      />

      <IWaveSearchFilter
        label={translate('IWAVE_FILTER_PLANNED_GIVING')}
        name={IWaveStat.PLANNED_GIVING}
      />
    </>
  );
}
